import React from "react";
const Anchorable = ({ nodeId, children }) => {
  return React.cloneElement(React.Children.only(children), {
    id: `viewer-${nodeId}`,
    tabIndex: -1
  });
};
export {
  Anchorable
};
//# sourceMappingURL=anchorable.js.map
